/*
 * Shared by the payroll pages:
 *   CXOPanel/cxoPayRoll.js        (Pay Roll)
 *   SuperAdminPanel/payRollCtc.js (Salary Analysis)
 */
import moment from "moment";
import { monthData, yearData } from "../../Utils/dataConstants";
import { formatINR } from "./transactionCommon";

/** numbers → ₹1,23,456.00; anything else (already formatted text) shown as it comes */
export const money = (v) =>
  v === null || v === undefined || v === "" ? "—" : Number.isFinite(Number(v)) ? formatINR(v) : String(v);

/** 12.345 → "12.35%"; text like "12%" shown as it comes */
export const percent = (v) =>
  v === null || v === undefined || v === ""
    ? "—"
    : Number.isFinite(Number(v))
      ? `${Number(Number(v).toFixed(2))}%`
      : String(v);

export const currentYear = () => yearData.find((y) => y._id === Number(moment().format("YYYY"))) || "";
export const currentMonth = () => monthData.find((m) => m._id === Number(moment().format("M"))) || "";

/** "October 2026" or "January – March 2026" */
export const periodLabel = (f) =>
  [f.startMonth?.name, f.endMonth?.name !== f.startMonth?.name && f.endMonth?.name].filter(Boolean).join(" – ") +
  (f.year?.name ? ` ${f.year.name}` : "");

/** Year + Start / End Month drawer fields (required, default to this month) */
export const buildPeriodFilterFields = () => [
  {
    key: "year",
    label: "Year",
    type: "dropdown",
    options: yearData,
    isRequired: true,
    clearable: false,
    defaultValue: currentYear,
  },
  {
    key: "startMonth",
    label: "Start Month",
    type: "dropdown",
    options: monthData,
    half: true,
    isRequired: true,
    defaultValue: currentMonth,
  },
  {
    key: "endMonth",
    label: "End Month",
    type: "dropdown",
    options: monthData,
    half: true,
    isRequired: true,
    defaultValue: currentMonth,
    validate: (value, v) =>
      value && v.startMonth && value._id < v.startMonth._id ? "End month can't be before the start month" : "",
  },
];
